var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { BTabs, BTab, BRow, BCol, BImg, BButtonGroup, BButton, BAlert, BCardBody, BModal, VBModal, ModalPlugin, BOverlay } from 'bootstrap-vue';
import axios from 'axios';
import sum from 'lodash/sum';
import debounce from 'lodash/debounce';
Vue.use(ModalPlugin);
// Load tabs
import ArtworkSize from 'components/picture-frames/Tabs/ArtworkSize.vue';
import MouldingOptions from 'components/picture-frames/Tabs/MouldingOptions.vue';
import MountOptions from 'components/picture-frames/Tabs/MountOptions.vue';
import GlazingOptions from 'components/picture-frames/Tabs/GlazingOptions.vue';
import FrameExtras from 'components/picture-frames/Tabs/FrameExtras.vue';
import FrameProductExtras from 'components/picture-frames/Tabs/FrameExtras/FrameProductExtras.vue';
import ReviewOrder from 'components/picture-frames/Tabs/ReviewOrder.vue';
import FrameVisualisation from 'components/picture-frames/FrameVisualisation.vue';
import MouldingSampleAddToCart from 'components/picture-frames/MouldingSampleAddToCart.vue';
import FrameSizeDetails from 'components/picture-frames/FrameSizeDetails.vue';
import ImageUploader from 'components/picture-frames/ImageUploader.vue';
import { DesignerStorage, ImageStorage } from 'ts/modules/designerStorage';
import { getRebateDimensions, getVisualisationUrl } from 'ts/modules/frameDesigner';
import { getVatMode, isAdmin } from 'ts/modules/helpers';
import { getBespokeFramePriceBreakdown } from 'ts/modules/pricing';
import { validateFrame } from 'ts/modules/validation';
let Designer = class Designer extends Vue {
    defaultSku;
    isQuickCheckout = false;
    vatMode = 'ex';
    loading = false;
    frame = {
        size: { width: 210, length: 297 },
        moulding: null,
        mount: {
            type: 'none',
            top: null,
            bottom: null,
            borders: { top: 50, bottom: 50, left: 50, right: 50 },
            reveal: 3
        },
        glazing: null,
        extras: {
            backing: false,
            fixings: false,
            undermount: false,
            fastmount: false,
            spacer: false
        },
        imageName: null
    };
    quantity = 1;
    imageName = null;
    prices = {
        frame: { price: '0.00', exVatPrice: '0.00' },
        mount: { price: '0.00', exVatPrice: '0.00' },
        glazing: { price: '0.00', exVatPrice: '0.00' },
        backing: { price: '0.00', exVatPrice: '0.00' },
        undermount: { price: '0.00', exVatPrice: '0.00' },
        fastmount: { price: '0.00', exVatPrice: '0.00' },
        fixings: { price: '0.00', exVatPrice: '0.00' },
        spacer: { price: '0.00', exVatPrice: '0.00' }
    };
    // Store of frame options
    storage = new DesignerStorage();
    imgStorage = new ImageStorage();
    // Current tab index
    currentTab = 0;
    frameErrors = [];
    isAdmin = false;
    Tabs = {
        ArtworkSize: 0,
        MouldingOptions: 1,
        MountOptions: 2,
        GlazingOptions: 3,
        FrameExtras: 4,
        ReviewOrder: 5
    };
    visitedTabs = [0];
    discountedPrice = null;
    discount = 0;
    get totalPrice() {
        return sum([
            parseFloat(this.prices.frame.price),
            this.nonFramePrice
        ]).toFixed(2);
    }
    get exVatTotalPrice() {
        return sum([
            parseFloat(this.prices.frame.exVatPrice),
            parseFloat(this.prices.glazing.exVatPrice),
            parseFloat(this.prices.mount.exVatPrice),
            parseFloat(this.prices.backing.exVatPrice),
            parseFloat(this.prices.fixings.exVatPrice),
            parseFloat(this.prices.undermount.exVatPrice),
            parseFloat(this.prices.fastmount.exVatPrice),
            parseFloat(this.prices.spacer.exVatPrice)
        ]).toFixed(2);
    }
    get nonFramePrice() {
        return sum([
            parseFloat(this.prices.glazing.price),
            parseFloat(this.prices.mount.price),
            parseFloat(this.prices.backing.price),
            parseFloat(this.prices.fixings.price),
            parseFloat(this.prices.undermount.price),
            parseFloat(this.prices.fastmount.price),
            parseFloat(this.prices.spacer.price)
        ]);
    }
    /**
     * Calculate and get the rebate dimensions of the frame
     */
    get rebateDimensions() {
        return getRebateDimensions(this.frame.size, this.frame.mount.type != 'none' ? this.frame.mount.borders : null);
    }
    /**
     * Get the link to the moulding detail page
     */
    get diyHref() {
        if (!this.frame.moulding) {
            return '#';
        }
        return `/picture-frame-mouldings/detail/Moulding/${this.frame.moulding?.sku.replace('AQ.', '')}`;
    }
    get visualisationUrl() {
        return getVisualisationUrl(this.frame.moulding?.sku || null, this.rebateDimensions, { width: this.frame.size.width - 6, length: this.frame.size.length - 6 }, this.frame.mount, this.frame.extras.backing, this.imageName);
    }
    get scaleUrl() {
        return `/api/frameDesigner/scaleImage?sku=${this.frame.moulding?.sku}&width=${this.rebateDimensions.width}&length=${this.rebateDimensions.length}`;
    }
    debouncedValidateFrame = debounce(this.validateFrame, 350);
    async validateFrame() {
        if (this.frame.moulding) {
            let validation = await validateFrame(this.frame.moulding?.sku, this.rebateDimensions);
            this.frameErrors = validation.problems;
        }
        else {
            this.frameErrors = [];
        }
    }
    onQuickUploadImage() {
        this.$bvModal.show('image-upload');
    }
    onRotate() {
        this.frame.size = {
            width: this.frame.size.length,
            length: this.frame.size.width
        };
    }
    /**
     * Quick jumping across tabs
     */
    onJumpTab(index) {
        this.currentTab = index;
    }
    onTabChange() {
        if (this.visitedTabs.indexOf(this.currentTab) === -1) {
            this.visitedTabs.push(this.currentTab);
        }
    }
    hasVisitedTab(tabIndex) {
        return this.visitedTabs.indexOf(tabIndex) !== -1;
    }
    /**
     * Watch for changes to the selected frame options
     */
    debouncedUpdate = debounce(this.onUpdate, 350);
    async onUpdate() {
        this.loading = true;
        // Automatically select backing when glazing chosen
        if (this.frame.glazing && !this.frame.extras.backing) {
            this.frame.extras.backing = true;
        }
        // Save to local storage
        this.storage.save(this.frame);
        // Calculate the price breakdown
        this.prices = await getBespokeFramePriceBreakdown(this.frame);
        await this.onQuantityChange();
        this.loading = false;
    }
    debouncedQuantityChange = debounce(this.onQuantityChange, 350);
    async onQuantityChange() {
        if (this.quantity == 1) {
            this.discountedPrice = this.totalPrice;
            this.discount = 0;
        }
        else {
            let { data } = await axios
                .get('/api/pricing/discounts/discountedPrice', {
                params: {
                    sku: `BF-${this.frame.moulding?.sku}`,
                    price: this.exVatTotalPrice,
                    quantity: this.quantity
                }
            });
            this.discountedPrice = data.price;
            this.discount = data.discount;
        }
    }
    onImageUpload(fileName) {
        this.imageName = fileName;
        this.imgStorage.save(fileName);
        this.$bvModal.hide('image-upload');
    }
    onImageRemove() {
        this.imageName = null;
    }
    /**
     * On create load any options stored in local storage
     */
    created() {
        const options = this.storage.load();
        if (options) {
            this.frame = options;
        }
        const urlParams = new URLSearchParams(window.location.search);
        this.isQuickCheckout = (Number(urlParams.get('quickCheckout')) || 0) == 1;
        // Check if there is a default sku of moulding
        if (this.defaultSku) {
            axios
                .get('/api/frameDesigner/moulding', {
                params: {
                    sku: this.defaultSku
                }
            })
                .then(({ data }) => this.frame.moulding = data);
        }
        this.imageName = this.imgStorage.load();
        this.vatMode = getVatMode();
        // Check if the user is an admin
        isAdmin()
            .then(isAdmin => this.isAdmin = isAdmin);
        if (this.isQuickCheckout) {
            this.currentTab = this.Tabs.ReviewOrder;
        }
    }
};
__decorate([
    Prop({ type: String, required: false })
], Designer.prototype, "defaultSku", void 0);
__decorate([
    Watch('frame.moulding', { deep: true }),
    Watch('rebateDimensions', { deep: true })
], Designer.prototype, "debouncedValidateFrame", void 0);
__decorate([
    Watch('currentTab')
], Designer.prototype, "onTabChange", null);
__decorate([
    Watch('frame', { deep: true })
], Designer.prototype, "debouncedUpdate", void 0);
__decorate([
    Watch('quantity')
], Designer.prototype, "debouncedQuantityChange", void 0);
Designer = __decorate([
    Component({
        components: {
            BTabs, BTab, BRow, BCol, BImg, BButtonGroup, BButton, BAlert, BCardBody, BModal, BOverlay,
            ArtworkSize, MouldingOptions, MountOptions, GlazingOptions, FrameExtras, ReviewOrder,
            MouldingSampleAddToCart, FrameVisualisation, FrameSizeDetails, ImageUploader, FrameProductExtras
        },
        directives: {
            'b-modal': VBModal
        }
    })
], Designer);
export default Designer;
